const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_419da4a4-c2d8-43a0-81d2-8591121c3d6f/artifacts/ykdt1rwm_Video_Generation_Heat_Transfer_Sublimation.mp4";

export const serviceRichContent = {
  "screen-printing": {
    videoUrl: HERO_VIDEO,
    videoCaption: "Watch: Inside our Dallas screen printing production floor",
    richContent: [
      {
        heading: "Why Dallas Businesses Choose Screen Printing",
        image: "https://images.unsplash.com/photo-1663433541063-ddab084d1126?w=1200&q=80",
        imageAlt: "Screen printing operator working on custom t-shirts at a Dallas print shop",
        paragraphs: [
          "Screen printing remains the most trusted method for producing custom apparel in high volumes across the Dallas-Fort Worth metroplex. From corporate offices in Uptown Dallas to school districts in Plano and Frisco, organizations choose screen printing because it delivers the lowest per-piece cost at quantities of 24 or more.",
          "Unlike digital methods, screen printing uses Plastisol and water-based inks that are physically pushed through a mesh stencil onto the garment — creating prints that withstand hundreds of wash cycles without cracking, fading, or peeling.",
          "At Ninja Screen Print, we've fulfilled screen printing orders for State Fair of Texas vendors, Deep Ellum music venues, Bishop Arts District boutiques, and Fortune 500 companies headquartered in the DFW Metroplex."
        ],
        highlights: [
          { label: "Cost Per Piece", value: "From $5.00", detail: "at 288+ units" },
          { label: "Wash Durability", value: "200+ Cycles", detail: "no cracking or fading" },
          { label: "Color Matching", value: "Pantone PMS", detail: "exact brand colors" }
        ],
        links: [
          { anchor: "Get a free screen printing quote", to: "/contact" },
          { anchor: "Compare with DTF printing for smaller orders", to: "/services/dtf-printing" }
        ]
      },
      {
        heading: "Our Screen Printing Process",
        subheading: "From Artwork to Finished Product — 7 Steps",
        image: "https://images.unsplash.com/photo-1586939735437-d61392bd039b?w=1200&q=80",
        imageAlt: "Screen printing frame with colorful ink being applied to a mesh stencil",
        paragraphs: [
          "Every screen printing order at our Dallas facility follows a proven 7-step production process designed for consistency and quality."
        ],
        steps: [
          { title: "Artwork Review", desc: "Our in-house designers review your artwork and prepare print-ready color separations — free with every order." },
          { title: "Screen Burning", desc: "We burn custom screens using high-resolution film positives, one screen per ink color." },
          { title: "Ink Mixing", desc: "Your exact ink colors are mixed using the Pantone Matching System (PMS) for precise brand color reproduction." },
          { title: "Press Setup", desc: "Our operators register each screen on automatic presses for pixel-perfect multi-color alignment." },
          { title: "Production Run", desc: "Printing runs at high speed while our quality control team inspects prints in real time." },
          { title: "Curing", desc: "Garments pass through a conveyor dryer at precisely calibrated temperatures to permanently cure the ink." },
          { title: "QC & Delivery", desc: "Every order undergoes count, fold, and packaging inspection before free delivery anywhere in DFW." }
        ],
        links: [
          { anchor: "Explore our graphic design services", to: "/services/graphic-design" },
          { anchor: "View our full blank garment catalog", to: "/product-catalog" }
        ]
      },
      {
        heading: "Screen Printing for Dallas Events & Organizations",
        image: "https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?w=1200&q=80",
        imageAlt: "Group of people wearing matching custom printed t-shirts at a Dallas event",
        paragraphs: [
          "Dallas is one of the most event-rich cities in the country, and screen-printed apparel is at the center of it all. We've printed custom t-shirts for 5K charity runs at White Rock Lake, staff uniforms for restaurants along Lower Greenville, and team jerseys for youth soccer leagues in Allen and McKinney.",
          "Schools across DFW — from DISD elementary schools to SMU Greek organizations — rely on Ninja Screen Print for spirit wear, fundraiser shirts, and graduation merchandise.",
          "Our standard 7-10 business day turnaround works for most events, but we also offer rush service for those last-minute Dallas moments."
        ],
        highlights: [
          { label: "Standard", value: "7-10 Days", detail: "production turnaround" },
          { label: "Rush", value: "3-4 Days", detail: "+$4.00 per piece" },
          { label: "Min. Order", value: "6 Pieces", detail: "for screen printing" }
        ],
        links: [
          { anchor: "Order custom team jerseys", to: "/services/custom-jerseys" },
          { anchor: "Set up a team store for group orders", to: "/team-store" },
          { anchor: "Check current screen printing pricing", to: "/pricing" }
        ]
      },
      {
        heading: "Screen Printing vs. DTF Printing",
        subheading: "Choosing the Right Method for Your Dallas Project",
        image: "https://images.unsplash.com/photo-1740126102414-fee092192258?w=1200&q=80",
        imageAlt: "Man operating a screen printing machine in a Dallas production facility",
        paragraphs: [
          "One of the most common questions we hear from Dallas customers is: should I choose screen printing or DTF? The answer depends on three factors: quantity, design complexity, and budget."
        ],
        comparison: [
          { method: "Screen Printing", points: ["Best for 24+ pieces", "1-6 solid ink colors", "Lowest per-piece cost at volume", "Most durable prints", "Setup fee under 24 pcs"] },
          { method: "DTF Printing", points: ["No minimum order", "Unlimited colors at same price", "Photographic / gradient designs", "Works on all fabric types", "No setup fees ever"] }
        ],
        paragraphs2: [
          "Many of our Dallas clients use both methods: screen printing for large bulk reorders and DTF for limited-edition drops, samples, or test runs before committing to a larger screen print order."
        ],
        links: [
          { anchor: "Learn more about DTF printing", to: "/services/dtf-printing" },
          { anchor: "Try our instant quote calculator", to: "/pricing" },
          { anchor: "Request a free consultation", to: "/contact" }
        ]
      },
      {
        heading: "Screen Printing Pricing & Free DFW Delivery",
        image: "https://images.unsplash.com/photo-1582469062319-9d6a6a9eb4f2?w=1200&q=80",
        imageAlt: "Delivery truck for free local Dallas-Fort Worth delivery of custom printed apparel",
        paragraphs: [
          "Transparent pricing is a core value at Ninja Screen Print. Our screen printing starts at $8.50 per piece for 48-71 units with a single color print, and we publish our full pricing tiers right on our website — no hidden fees, no surprise charges.",
          "Screen setup fees are waived on all orders of 24+ pieces. Every order of 24 or more pieces includes free delivery to any address in Dallas, Fort Worth, Arlington, Plano, Frisco, McKinney, Irving, Grand Prairie, Garland, Mesquite, Richardson, and all other DFW metro cities.",
          "We also offer specialty add-ons like puff ink, metallic foil, and glow-in-the-dark effects for brands that want extra premium impact."
        ],
        links: [
          { anchor: "View full screen printing pricing", to: "/pricing" },
          { anchor: "Explore specialty printing effects", to: "/services/specialty-printing" },
          { anchor: "Check if we deliver to your area", to: "/service-area" }
        ]
      }
    ]
  },

  "dtf-printing": {
    richContent: [
      {
        heading: "What Makes DTF Printing the Future of Custom Apparel",
        image: "https://images.unsplash.com/photo-1581092160607-ee22731c9e11?w=1200&q=80",
        imageAlt: "DTF printing equipment producing vibrant full-color garment transfers",
        paragraphs: [
          "Direct to Film (DTF) printing has transformed the custom apparel industry in Dallas-Fort Worth by eliminating the barriers that traditionally kept small businesses and individuals from ordering custom printed clothing.",
          "Unlike screen printing which requires screen creation and minimum orders, DTF produces your design on a special PET transfer film using CMYK + white ink, then heat-presses it directly onto your garment. The result is a vibrant, soft-feel, full-color print that bonds permanently to virtually any fabric type.",
          "Whether you're a Deep Ellum boutique owner printing 5 limited-edition tees or an Arlington startup testing 50 branded polos, DTF makes it possible — and affordable."
        ],
        highlights: [
          { label: "Minimum Order", value: "1 Piece", detail: "no minimums required" },
          { label: "Colors", value: "Unlimited", detail: "at no extra cost" },
          { label: "Setup Fees", value: "$0", detail: "never any setup fees" }
        ],
        links: [
          { anchor: "Get a DTF printing quote", to: "/contact" },
          { anchor: "Compare DTF and screen printing prices", to: "/pricing" }
        ]
      },
      {
        heading: "When to Choose DTF Over Screen Printing",
        image: "https://images.unsplash.com/photo-1503342394128-c104d54dba01?w=1200&q=80",
        imageAlt: "Custom designed apparel featuring full-color photographic prints",
        paragraphs: [
          "The decision between DTF and screen printing comes down to four key factors that we help every Dallas customer evaluate:"
        ],
        checklist: [
          "Your order is under 24 pieces — DTF has no minimum and no setup fees",
          "Your design uses photographic images, gradients, or more than 6 colors",
          "You're printing on polyester, nylon, or performance fabrics",
          "You need it fast — DTF turnaround is 5-7 business days with rush available"
        ],
        paragraphs2: [
          "Choose screen printing when your order exceeds 24 pieces with simple 1-6 color designs — at those volumes, screen printing delivers better per-piece economics. Many clients use both: DTF for samples and small runs, then screen printing for production reorders."
        ],
        links: [
          { anchor: "Learn about screen printing for larger orders", to: "/services/screen-printing" },
          { anchor: "Use our quote calculator to compare pricing", to: "/pricing" },
          { anchor: "Browse blank garments in our catalog", to: "/product-catalog" }
        ]
      },
      {
        heading: "DTF Printing for Dallas Small Businesses",
        image: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1200&q=80",
        imageAlt: "Small business owner reviewing custom printed merchandise in Dallas",
        paragraphs: [
          "Dallas-Fort Worth has one of the fastest-growing small business ecosystems in the country, and DTF printing is the perfect match for entrepreneurs who need custom branded apparel without overcommitting on inventory.",
          "We've served food truck operators at Klyde Warren Park who needed 10 branded tees, Etsy sellers in Denton creating custom designs for online stores, fitness trainers in Plano wanting 3 branded tank tops, and real estate agents in Southlake ordering 5 polos with their headshot and logo.",
          "DTF lets you start small, test your designs with real customers, and scale up when demand grows."
        ],
        links: [
          { anchor: "Get professional graphic design for your brand", to: "/services/graphic-design" },
          { anchor: "Explore custom embroidered polos for a premium look", to: "/services/embroidery" },
          { anchor: "Set up a team store for your brand", to: "/team-store" }
        ]
      },
      {
        heading: "The DTF Printing Process",
        subheading: "How We Produce Your Custom Transfers in Dallas",
        image: "https://images.unsplash.com/photo-1612832164313-ac0d25fe4d10?w=1200&q=80",
        imageAlt: "Heat press applying a DTF transfer onto a custom t-shirt",
        paragraphs: [
          "Our DTF production process uses commercial-grade equipment to ensure every transfer meets professional standards."
        ],
        steps: [
          { title: "Upload Artwork", desc: "We accept vector files (AI, EPS, PDF) and high-resolution rasters (PNG, TIFF at 300 DPI)." },
          { title: "Pre-Press", desc: "Our team prepares the file with proper color profiles and white underbase generation." },
          { title: "Film Printing", desc: "Design is printed onto PET transfer film using eco-solvent CMYK + white ink in a single pass." },
          { title: "Powder & Cure", desc: "Specialized adhesive powder is applied to the wet ink surface and cured in our oven." },
          { title: "Heat Press", desc: "The transfer is heat-pressed onto your garment at 325°F for 15 seconds, creating a permanent bond." },
          { title: "Final QC", desc: "We peel the film and do a final quality check. Results: smooth, flexible, 50+ wash cycle durability." }
        ],
        links: [
          { anchor: "Submit your artwork for a free review", to: "/contact" },
          { anchor: "Check our DTF pricing tiers", to: "/pricing" }
        ]
      },
      {
        heading: "DTF Printing Works on Any Fabric",
        subheading: "Including Polyester and Performance Wear",
        image: "https://images.unsplash.com/photo-1558171813-01eda332e082?w=1200&q=80",
        imageAlt: "Various fabric types suitable for DTF printing including polyester and cotton blends",
        paragraphs: [
          "One of DTF's biggest advantages over screen printing is its ability to produce vibrant, durable prints on fabrics that traditional methods struggle with.",
          "Screen printing on 100% polyester can cause dye migration — where the garment dye bleeds through the ink. DTF's white underbase layer acts as a barrier, preventing dye migration entirely.",
          "This makes DTF ideal for performance athletic wear, polyester polos for corporate teams in the Telecom Corridor, nylon jackets, tri-blend fashion tees, and even non-traditional materials like canvas bags."
        ],
        links: [
          { anchor: "Explore our custom jersey program", to: "/services/custom-jerseys" },
          { anchor: "See available garment brands and styles", to: "/product-catalog" },
          { anchor: "Check if we serve your DFW city", to: "/service-area" }
        ]
      }
    ]
  },

  "embroidery": {
    richContent: [
      {
        heading: "Professional Embroidery for Dallas Businesses",
        image: "https://images.unsplash.com/photo-1614904301802-53243f11a17c?w=1200&q=80",
        imageAlt: "Close-up of professional embroidery stitching on fabric",
        paragraphs: [
          "Embroidery is the gold standard for professional branded apparel. When your team walks into a client meeting in Uptown, a trade show at the Dallas Market Center, or a networking event at the Omni Hotel, embroidered logos communicate quality and permanence that printed designs simply cannot match.",
          "We've embroidered corporate polos for law firms on Elm Street, medical scrubs for clinics in the Medical District, and hospitality uniforms for hotels along the DART rail corridor.",
          "The raised, textured quality of embroidery doesn't fade, crack, or peel — it's stitched permanently into the fabric and actually improves with wear."
        ],
        highlights: [
          { label: "Durability", value: "Permanent", detail: "outlasts the garment" },
          { label: "Starting At", value: "$7.50/pc", detail: "at 144+ pieces" },
          { label: "Thread Colors", value: "Unlimited", detail: "multi-color logos" }
        ],
        links: [
          { anchor: "Get an embroidery quote for your team", to: "/contact" },
          { anchor: "See our blank polo and jacket options", to: "/product-catalog" }
        ]
      },
      {
        heading: "How Our Dallas Embroidery Process Works",
        image: "https://images.unsplash.com/photo-1558196964-59a6bcb24cc5?w=1200&q=80",
        imageAlt: "Commercial embroidery machine stitching a custom logo design",
        paragraphs: [
          "Every embroidery project begins with digitizing — converting your logo into a stitch file that our machines can read. Our digitizing team manually programs stitch direction, density, underlay patterns, and color sequence."
        ],
        steps: [
          { title: "Digitizing", desc: "We convert your logo into a stitch file — manually programmed for optimal results at size." },
          { title: "Digital Proof", desc: "You receive a digital proof showing exactly how your logo will look when stitched." },
          { title: "Production", desc: "Our multi-head commercial machines stitch up to 12 garments simultaneously." },
          { title: "Quality Check", desc: "Our team trims jump threads, inspects stitch coverage, and packages for free DFW delivery." }
        ],
        paragraphs2: [
          "Your digitized file is stored permanently — meaning all future reorders skip digitizing entirely, saving you time and money."
        ],
        links: [
          { anchor: "Submit your logo for free digitizing review", to: "/contact" },
          { anchor: "Need a logo designed from scratch?", to: "/services/graphic-design" }
        ]
      },
      {
        heading: "Embroidery for Dallas Schools, Teams & Organizations",
        image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=1200&q=80",
        imageAlt: "Students and team members wearing embroidered polo shirts and jackets",
        paragraphs: [
          "Schools, athletic departments, churches, and community organizations across DFW rely on embroidered apparel for a polished, unified look.",
          "We've embroidered varsity letter jackets for Plano high schools, staff polos for Richardson ISD, baseball caps for Little League teams in Mansfield, and golf shirts for charity tournaments at TPC Craig Ranch in McKinney.",
          "For teams needing both embroidery (polos, hats) and screen printing (event tees, practice shirts), we offer combination packages that save on setup costs."
        ],
        links: [
          { anchor: "Explore our team store for group orders", to: "/team-store" },
          { anchor: "Order custom team jerseys with names and numbers", to: "/services/custom-jerseys" },
          { anchor: "Check embroidery pricing for your quantity", to: "/pricing" }
        ]
      },
      {
        heading: "Embroidery vs. Screen Printing",
        subheading: "Which Is Right for Your Dallas Project?",
        image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=1200&q=80",
        imageAlt: "Comparison of embroidered polo shirt and screen printed t-shirt",
        paragraphs: [
          "Choosing between embroidery and screen printing depends on the garment type, the look you want, and your budget."
        ],
        comparison: [
          { method: "Choose Embroidery", points: ["Polos, button-downs, jackets, hats", "Premium, textured look", "Priced by stitch count", "Best for logos under 8,000 stitches", "Survives industrial laundering"] },
          { method: "Choose Screen Printing", points: ["T-shirts, hoodies, tank tops", "Smooth, flat graphic designs", "Priced by number of colors", "Best for large, multi-color graphics", "Most cost-effective at volume"] }
        ],
        paragraphs2: [
          "We recommend embroidery for anything you'd wear to a boardroom, and screen printing for anything you'd wear to a barbecue."
        ],
        links: [
          { anchor: "Compare with screen printing for t-shirts", to: "/services/screen-printing" },
          { anchor: "Consider DTF for small quantity soft-feel prints", to: "/services/dtf-printing" },
          { anchor: "Use our quote calculator to compare costs", to: "/pricing" }
        ]
      }
    ]
  },

  "graphic-design": {
    richContent: [
      {
        heading: "Print-Specialized Graphic Design in Dallas",
        image: "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=1200&q=80",
        imageAlt: "Graphic designer creating custom apparel artwork on a computer",
        paragraphs: [
          "Not all graphic designers understand the technical requirements of garment printing — but ours do. Ninja Screen Print's in-house design team in Dallas specializes exclusively in apparel graphics.",
          "We understand color separations for screen printing, stitch count limitations for embroidery, white underbase requirements for DTF, and how designs scale from youth small to adult 5XL.",
          "Whether you need a brand-new logo for your Fort Worth food truck, a vintage-style event shirt for a Deep Ellum music fest, or a professional polo design for your Plano medical practice — our designers deliver artwork that prints perfectly the first time."
        ],
        highlights: [
          { label: "Turnaround", value: "2-3 Days", detail: "standard design delivery" },
          { label: "Revisions", value: "3 Rounds", detail: "included in every project" },
          { label: "Ownership", value: "100%", detail: "you own all artwork" }
        ],
        links: [
          { anchor: "Request a design consultation", to: "/contact" },
          { anchor: "Explore screen printing production", to: "/services/screen-printing" }
        ]
      },
      {
        heading: "Our Design Process for Custom Apparel",
        image: "https://images.unsplash.com/photo-1558655146-364adaf1fcc9?w=1200&q=80",
        imageAlt: "Custom apparel design mockups and proofs being reviewed",
        paragraphs: [
          "Our design process is collaborative and transparent — here's how it works."
        ],
        steps: [
          { title: "Share Your Vision", desc: "A rough sketch, Pinterest board, brand colors, a competitor's shirt you admire, or just a description." },
          { title: "Concept Directions", desc: "We create 2-3 initial concepts presented as digital mockups on your selected garment." },
          { title: "Refine & Perfect", desc: "Pick a direction and we refine through up to 3 rounds of revisions (included)." },
          { title: "Final Delivery", desc: "Artwork delivered in all formats — vector (AI, EPS, PDF) and raster (PNG, TIFF). You own 100%." }
        ],
        links: [
          { anchor: "Browse blank garments for your project", to: "/product-catalog" },
          { anchor: "Pair design with DTF printing for quick samples", to: "/services/dtf-printing" }
        ]
      },
      {
        heading: "Logo Design & Brand Identity",
        subheading: "Built for Print, Not Just Screens",
        image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=1200&q=80",
        imageAlt: "Brand identity logo design process for custom apparel printing",
        paragraphs: [
          "Your logo appears everywhere — business cards, websites, vehicle wraps, and most importantly, on the apparel worn by your team. A logo designed by a general graphic designer may look great on screen but can present serious challenges when embroidered or screen printed.",
          "Our logo design service considers production from day one. We ensure adequate line weight for embroidery, proper color count for screen printing, and clean vector paths for crisp reproduction at any size.",
          "Every logo project includes a full brand guide with color codes (Pantone, CMYK, RGB, HEX), minimum size specs, and usage guidelines for apparel, print, and digital."
        ],
        links: [
          { anchor: "Order embroidered items with your new logo", to: "/services/embroidery" },
          { anchor: "Start a logo design project today", to: "/contact" }
        ]
      },
      {
        heading: "Artwork Preparation Tips",
        subheading: "File Specs for Screen Printing, DTF & Embroidery",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=1200&q=80",
        imageAlt: "Digital artwork files being prepared for custom garment printing production",
        paragraphs: [
          "Already have artwork? Here are the standards we work with at our Dallas facility:"
        ],
        checklist: [
          "Screen Printing: Vector files (AI, EPS, PDF) with fonts converted to outlines, minimum 1pt line thickness",
          "DTF Printing: High-resolution raster (PNG at 300 DPI min), transparent backgrounds preferred",
          "Embroidery: Vector logos convert best, avoid thin script fonts under 0.25\" and details smaller than 1mm",
          "Not sure? Submit what you have — our art team provides free file review with every print order"
        ],
        links: [
          { anchor: "Submit your artwork for free review", to: "/contact" },
          { anchor: "Explore specialty effects like puff and foil", to: "/services/specialty-printing" }
        ]
      }
    ]
  },

  "custom-jerseys": {
    richContent: [
      {
        heading: "Custom Team Jerseys for Every DFW Sport",
        image: "https://images.unsplash.com/photo-1655089131279-8029e8a21ac6?w=1200&q=80",
        imageAlt: "Custom sports jerseys hanging on a rack ready for team distribution",
        paragraphs: [
          "The DFW metroplex is home to one of the largest youth and recreational sports communities in the nation. From YMCA basketball leagues in Irving to competitive travel soccer in Frisco, Ninja Screen Print is the team jersey partner trusted by coaches and athletic directors across the region.",
          "We handle everything — from blank garment selection (performance polyester, moisture-wicking mesh, and cotton-blend options) to design, individual player name and number application, and direct delivery."
        ],
        highlights: [
          { label: "Minimum", value: "6 Jerseys", detail: "per team order" },
          { label: "Names/Numbers", value: "Included", detail: "individual roster" },
          { label: "Delivery", value: "Free DFW", detail: "on 24+ pieces" }
        ],
        links: [
          { anchor: "Get a team jersey quote", to: "/contact" },
          { anchor: "Browse performance wear in our catalog", to: "/product-catalog" }
        ]
      },
      {
        heading: "How Our Custom Jersey Process Works",
        image: "https://images.unsplash.com/photo-1635863974852-c45cb5bec863?w=1200&q=80",
        imageAlt: "Team athletes wearing custom jerseys during a photo shoot",
        paragraphs: [
          "Ordering custom jerseys for your Dallas team is simple — we've streamlined the process so coaches can focus on their teams."
        ],
        steps: [
          { title: "Choose Your Style", desc: "Select from our catalog of performance blanks — Augusta, A4, Sport-Tek in team-friendly colors." },
          { title: "Share Your Logo", desc: "Send your team logo and colors. Need one designed? Starting at $75." },
          { title: "Submit Your Roster", desc: "Player names, numbers, and sizes on a simple spreadsheet." },
          { title: "Approve Your Proof", desc: "Digital proof showing front, back, and sleeve placement." },
          { title: "Production & Delivery", desc: "Standard 10-14 business days, rush available. Free DFW delivery on 24+." }
        ],
        links: [
          { anchor: "Set up a team store for individual player orders", to: "/team-store" },
          { anchor: "Explore graphic design for team logos", to: "/services/graphic-design" },
          { anchor: "Check our jersey pricing", to: "/pricing" }
        ]
      },
      {
        heading: "Serving Dallas Youth Leagues & School Athletics",
        image: "https://images.unsplash.com/photo-1517466787929-bc90951d0974?w=1200&q=80",
        imageAlt: "Youth athletes playing sports in custom printed team jerseys",
        paragraphs: [
          "Youth athletics are a way of life in DFW. From YMCA leagues in Coppell to competitive travel programs in Prosper and Celina, every team needs quality uniforms that look professional and perform on the field.",
          "We supply complete uniform packages for high school varsity, JV, and freshman programs — including home and away jerseys, practice shirts, warm-up gear, and coaching staff polos.",
          "Our team store platform lets each family order and pay individually — eliminating the headache of collecting payments from parents."
        ],
        links: [
          { anchor: "Add embroidered coaching staff polos", to: "/services/embroidery" },
          { anchor: "Check our DFW delivery coverage", to: "/service-area" }
        ]
      },
      {
        heading: "Jersey Customization Options",
        subheading: "Names, Numbers, Logos & More",
        image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=1200&q=80",
        imageAlt: "Custom jersey with player name and number being applied",
        paragraphs: [
          "Every team is unique, and our customization options reflect that."
        ],
        checklist: [
          "Front logo or team name (screen printed or sublimated)",
          "Back player name and number (heat-applied twill or screen printed)",
          "Optional sleeve logos or sponsor placements",
          "Captain patches, memorial patches, league badges",
          "All-over sublimation for fully custom patterns"
        ],
        links: [
          { anchor: "Get specialty effects for premium jerseys", to: "/services/specialty-printing" },
          { anchor: "Request a free jersey mockup", to: "/contact" },
          { anchor: "Try DTF for individual custom jerseys", to: "/services/dtf-printing" }
        ]
      }
    ]
  },

  "specialty-printing": {
    richContent: [
      {
        heading: "Specialty Print Effects in Dallas",
        image: "https://images.unsplash.com/photo-1580089470033-b564a216c4ae?w=1200&q=80",
        imageAlt: "Close-up of specialty metallic foil print effect on a custom garment",
        paragraphs: [
          "Standard screen printing delivers excellent results for most projects — but when your brand demands something extraordinary, our specialty techniques transform garments into premium collectible pieces.",
          "At our Dallas facility, we offer a comprehensive menu of specialty effects that very few DFW printers can match."
        ],
        checklist: [
          "Puff Ink — raised 3D textures for retro and streetwear looks",
          "Metallic Foil — mirror-like reflective gold, silver, rose gold, holographic",
          "Glow-in-the-Dark — nighttime visibility for concerts and events",
          "Discharge Printing — ultra-soft vintage feel on dark garments",
          "Glitter Ink — sparkle effects for fashion and promotional items",
          "High-Density Silicone — raised rubberized textures",
          "Suede-Finish Ink — velvet-like touch for premium pieces"
        ],
        links: [
          { anchor: "Get a specialty printing quote", to: "/contact" },
          { anchor: "Pair with our graphic design service", to: "/services/graphic-design" }
        ]
      },
      {
        heading: "Puff Ink, Foil & Metallic Printing",
        subheading: "Our Most Requested Specialty Effects",
        image: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=1200&q=80",
        imageAlt: "Fashion apparel featuring puff ink and metallic foil print effects",
        paragraphs: [
          "Our three most-requested effects each serve a distinct creative purpose:",
          "Puff ink contains a heat-reactive additive that creates a raised, puffy texture — perfect for retro logos and streetwear. Metallic foil applies a thin metallic film (gold, silver, rose gold, copper, holographic) for an eye-catching mirror finish. Metallic ink mixes fine metallic particles into the ink for a subtle shimmer without the hard foil edge.",
          "Metallic foil is the top choice for fashion brands, luxury event invitations, and premium merchandise at Dallas venues like the American Airlines Center and AT&T Performing Arts Center."
        ],
        links: [
          { anchor: "Combine specialty effects with screen printing", to: "/services/screen-printing" },
          { anchor: "Explore pricing for specialty add-ons", to: "/pricing" }
        ]
      },
      {
        heading: "Glow-in-the-Dark & Discharge Printing",
        subheading: "For Dallas Events & Fashion",
        image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=1200&q=80",
        imageAlt: "Concert venue with neon lights - perfect environment for glow-in-the-dark printed apparel",
        paragraphs: [
          "Dallas's nightlife and event scene creates unique demand for effects that perform after dark. Our glow-in-the-dark inks absorb light and emit a bright glow — perfect for concert merch at The Bomb Factory, South Side Ballroom, and Gilley's Dallas.",
          "On the opposite end, discharge printing is the go-to for fashion-forward brands wanting the softest possible print. Discharge ink chemically removes the garment dye and replaces it with your design color, resulting in a print that feels like part of the fabric.",
          "It's the technique used by premium streetwear labels and is ideal for Comfort Colors and other pigment-dyed garments popular in the Dallas fashion scene."
        ],
        links: [
          { anchor: "Browse Comfort Colors and premium blanks", to: "/product-catalog" },
          { anchor: "Consider DTF for full-color event designs", to: "/services/dtf-printing" },
          { anchor: "Request samples of specialty effects", to: "/contact" }
        ]
      },
      {
        heading: "Specialty Printing for Dallas Fashion Brands",
        image: "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=1200&q=80",
        imageAlt: "Limited-edition streetwear collection featuring specialty print techniques",
        paragraphs: [
          "The Dallas creative scene — from Bishop Arts boutiques to Deep Ellum streetwear labels — is producing some of the most exciting independent fashion in the country.",
          "Imagine a streetwear hoodie with puff ink on the chest, discharge-printed back graphic, and metallic foil accents on the sleeves — all produced in a run of 50 pieces. That's the kind of premium, small-batch production that turns a local brand into a cult favorite.",
          "Our minimum for specialty printing is 24 pieces, with standard turnaround of 10-14 business days."
        ],
        links: [
          { anchor: "Start your specialty project with a free quote", to: "/contact" },
          { anchor: "See our full range of blank garments", to: "/product-catalog" },
          { anchor: "Set up a branded store for your label", to: "/team-store" }
        ]
      }
    ]
  }
};
